import { render } from "./ContextualBanner.vue?vue&type=template&id=18153153&scoped=true"
import script from "./ContextualBanner.vue?vue&type=script&lang=js"
export * from "./ContextualBanner.vue?vue&type=script&lang=js"

import "./ContextualBanner.vue?vue&type=style&index=0&id=18153153&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18153153"]])

export default __exports__